import React, { useState } from "react"
import { Container, Row, Col, Form, Button, InputGroup, Spinner } from "react-bootstrap"
import { FaEye, FaEyeSlash } from "react-icons/fa"
import { loginUser } from "../../Services/userService"
import toast from "react-hot-toast"
import { userLogin } from "../../Redux/authSlice"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import logo from "../../Assets/Images/logo.png";

const Login = () => {
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [companyPin, setCompanyPin] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)

    const dispatch = useDispatch()
    const navigate = useNavigate()


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!userName || !password) {
            toast.error("Username and password required");
            return;
        }

        setLoading(true);


        try {
            const response = await dispatch(
                userLogin({
                    type: "admin",
                    body: { userName, password, company_pin: companyPin }
                })
            ).unwrap();

            if (response?.status === "success") {
                console.log("login ", response)
                toast.success(response?.message || "Login successful");
                setUserName("");
                setPassword("");

                // redirect after redux state updated
                navigate("/", { replace: true });
            } else {
                toast.error(response?.message || "Login failed");
            }

        } catch (error) {
            // error from rejectWithValue
            toast.error(error || "Server error");
            console.log("Login error:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Container fluid
            style={{
                background: "var(--surface)",
            }}
            className="vh-100 d-flex align-items-center justify-content-center" >
            <Row className="w-100 justify-content-center">
                <Col md={4}>
                    <div className="p-4 shadow"
                        style={{
                            background: "var(--surface)",
                            border: "1px solid var(--border)",
                            borderRadius: 14, padding: "20px 22px"
                        }}
                    >
                        <div className="text-center mb-4">
                            <img src={logo} alt="Logo" className="img-fluid" style={{ maxWidth: "150px" }} />
                        </div>

                        <Form onSubmit={handleSubmit}>
                            {/* Username */}
                            <Form.Group className="mb-3">
                                <Form.Label className="oms-label-dark">Username</Form.Label>
                                <input
                                    className="oms-form-input"
                                    type="text"
                                    placeholder="Enter username"
                                    value={userName}
                                    onChange={(e) => setUserName(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="oms-label-dark">Company Pin</Form.Label>
                                <input
                                    className="oms-form-input"
                                    type="text"
                                    placeholder="Enter company pin"
                                    value={companyPin}
                                    onChange={(e) => setCompanyPin(e.target.value)}
                                />
                            </Form.Group>

                            {/* Password */}
                            <Form.Label className="oms-label-dark">Password</Form.Label>
                            <div className="oms-search  w-100 mb-3">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter password"
                                    className="w-100"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <span style={{ color: "var(--text-muted)", fontSize: 14 }}>
                                    {showPassword ? <FaEyeSlash onClick={() => setShowPassword(!showPassword)} /> : <FaEye onClick={() => setShowPassword(!showPassword)} />}

                                </span>
                            </div>

                            <button type="submit" className="w-100 justify-content-center oms-btn oms-btn-primary">
                                {
                                    loading ?
                                        <>
                                            <Spinner size="sm" animation="border" />
                                        </>
                                        : "Login"
                                }
                            </button>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container >
    )
}

export default Login
